import { render, staticRenderFns } from "./vendor.vue?vue&type=template&id=56732665&"
import script from "./vendor.vue?vue&type=script&lang=js&"
export * from "./vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports